function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var observerConfig = {
  // set up a Watch to child nodes
  childList: true,
  // Include all descendants of the target elements
  subtree: true
};

function callback(targetNode, mutationsList, observer) {
  // eslint-disable-next-line no-unused-vars
  var _iterator = _createForOfIteratorHelper(mutationsList),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var mutation = _step.value;
      console.log('Yotpo mutation:', mutation);

      if (mutation.type === 'childList') {
        mutation.addedNodes.forEach(function (node) {
          console.log('Yotpo mutation addedNode:', node);

          if (node instanceof HTMLElement) {
            var h2Elements = node.querySelectorAll('h2');
            h2Elements.forEach(function (h2) {
              console.log('Yotpo - replacing added H2 node with span:', h2);
              var span = document.createElement('span');
              span.textContent = h2.textContent;
              span.className = h2.className; // disconnect observer before making changes to avoid extra looping

              observer.disconnect();
              h2.parentNode.replaceChild(span, h2); // re-observe the target node after changes have been made

              observer.observe(targetNode, observerConfig);
            });
          }
        });
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
}

var yotpoObservers = [];
var targetElements = document.querySelectorAll('div.yotpo-pictures-widget, div.yotpo-pictures-widget-lazyload'); // Start observing the target elements

Array.from(targetElements).forEach(function (element) {
  console.log('Observing Yotpo target:', element);
  var observer = new MutationObserver(callback.bind(null, element));
  observer.observe(element, observerConfig);
  yotpoObservers.push(observer);
});